import { Component, Input } from '@angular/core';
import { Question } from '@app/core/models/questionnaire.model';
import { QuestionSubType } from '@app/core/enums/questionnaire.enums';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-sliders',
  imports: [CommonModule, FormsModule],
  templateUrl: './sliders.html',
  styleUrl: './sliders.scss'
})
export class Sliders {
  @Input() question: Question | null = null;
  questionSubType = QuestionSubType;
  min: number = 0;
  max: number = 10;
  value: number = 0;
  onChange = (value: number) => {};
  onTouched = () => {};

  ngOnInit() {
    this.min = Number(this.question?.questionSpecificOptions?.minValue) || 0;
    this.max = Number(this.question?.questionSpecificOptions?.scalePoints || 10);
    this.value = this.min;
  }

  onSliderChange(event: any) {
    this.value = Number(event.target.value);
    this.onChange(this.value);
    this.onTouched();
  }
}
